const SHARED_OBSERVER = new IntersectionObserver((entries, observer) => {
    for (const entry of entries) {
        const el = entry.target;
        el.style.visibility = entry.isIntersecting ? "visible" : "hidden";
    }
}, { root: null, rootMargin: "0px", threshold: 0 });
/**
 * A Vue.js directive to dynamically change the `visibility` property of an element.
 * <br>When the element is in the viewport, the property will be set to `visible`.
 * <br>When the element leaves the viewport, the property will be set to `hidden`.
 */
export const showVisible = {
    inserted: (el, binding, vnode) => {
        SHARED_OBSERVER.observe(el);
    },
    unbind: (el, binding, vnode) => {
        SHARED_OBSERVER.unobserve(el);
    }
};
//# sourceMappingURL=index.js.map